module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('email-filters', {
    on: {
      "filter": _vm.filter
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("\n                E-mail\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'email',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n              Status\n              "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'status',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Zaimportowany\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'was_imported',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Akcje\n            ")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.emails.show',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(item.email))])]), _vm._v(" "), _c('td', [(item) ? _c('email-status', {
      attrs: {
        "item": item
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.was_imported) ? _c('div', [_c('span', {
      staticClass: "label-black"
    }, [_vm._v("Tak.")]), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.imported_at_formated))])]) : _vm._e(), _vm._v(" "), (!item.was_imported) ? _c('div', [_c('span', {
      staticClass: "label"
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "mode_edit",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.emails.edit',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "highlight_off",
        "color": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(item)
        }
      }
    }, [_vm._v("Usuń")])], 1)])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1da2d86c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/List.vue
// module id = 229
// module chunks = 0